<app-error-page
  [code]="403"
  [title]="'ERROR_PAGES.FORBIDDEN' | translate"
  [message]="'ERROR_PAGES.FORBIDDEN_MESSAGE' | translate"
  [mainPageBtn]="true"
  [backBtn]="true"
></app-error-page>
